module.exports = __webpack_public_path__ + "img/sun-hero-logo.3a8ab216.png";